export const FIRST_TRACK_ACTIVITY_DELAY_MS = 10 * 1000;
export const TRACK_ACTIVITY_INTERVAL_MS = 60 * 1000;

type ActivityDecisionInput = {
    enabled: boolean;
    hadRealActivity: boolean;
    inFlight: boolean;
};

export const shouldSendActivityPing = ({ enabled, hadRealActivity, inFlight }: ActivityDecisionInput): boolean => {
    return enabled && hadRealActivity && !inFlight;
};

export const submitActivityPingSafely = (submit: () => void): boolean => {
    try {
        submit();
        return true;
    } catch (error) {
        return false;
    }
};
